
import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ApiService } from '../../services/api.service';
import { Product } from '../../models/product.model';
import { CreateEditProductModalComponent } from './create-edit-product-modal/create-edit-product-modal.component';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Group } from '../../models/group.model';
import { AccountService } from '../../services/account.service';
import { Permission } from '../../models/permission.model';
import { Angular5Csv } from '../../../../node_modules/angular5-csv/dist/Angular5-csv';
import * as _ from 'lodash';
import * as moment from 'moment';
import { EFulfillmentFormComponent } from './e-fulfillment-form/e-fulfillment-form.component';

@Component({
    selector: 'products',
    template: require('./products.component.html'),
    styles: [require('./products.component.css')],
    animations: [fadeInOut]
})
export class ProductsComponent {
    products: Product[];
    groupId: number;
    parentsLink = [];
    groups: Group[];

    productsPriceTotal: number = 0;
    productsCostTotal: number = 0;
    writePlansPermission = Permission.writePlansPermission;

    constructor(private router: Router, private route: ActivatedRoute, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService, public accountService: AccountService) {
        this.route.params.subscribe(params => {
            this.groupId = params['groupId'];
            this.getProducts();
        });

        this.getGroups();
    }

    openEFulfillment( plan ) {
        console.log(plan)

        var dialogRef = null;

        dialogRef = this.dialog.open(EFulfillmentFormComponent, {
            panelClass: 'col-sm-10',
            data: {
                plan: plan
            },
            disableClose: true,
            autoFocus: false
        })


        dialogRef.afterClosed().subscribe(r => {
            console.log(r)
            if (r.isSave) {
                this.getProducts();
            }
        })

    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

    getGroups() {
        this.apiService.getGroups().subscribe(r => {
            this.groups = r;
        })
    }

    getProducts() {
        this.products = [];
        if (this.groupId) {
            this.parentsLink = [{ name: 'Sponsors(' + this.groupId +')', link: 'groups' }];
            this.apiService.getProductsByGroupId(this.groupId).subscribe(r => {
                this.products = r;
                this.caclProductsPriceAndCost();
            })
        } else {
            this.apiService.getProducts().subscribe(r => {
                this.products = r;
                this.caclProductsPriceAndCost();
            })
        }
        
    }

    caclProductsPriceAndCost() {
        _.each(this.products, p => {
            this.productsPriceTotal += p.totalPrice;
            this.productsCostTotal += p.totalCost;
        })
        //this.productsPriceTotal = parseFloat(this.productsPriceTotal.toFixed(2));
        //this.productsCostTotal = parseFloat(this.productsCostTotal.toFixed(2));
    }

    createEditProduct(product: any) {
        let dialogRef = this.dialog.open(CreateEditProductModalComponent, {
            width: '600px',
            data: {
                currentProduct: product,
                groups: this.groups
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            if (r) {
                this.router.navigateByUrl("/products/" + r);
            }
            
        })
    }

    deleteProduct(productId: number) {
        this.alertService.showDialog("Do you want to delete this Product ?", DialogType.confirm, val => {

            this.apiService.deleteProduct(productId).subscribe(r => {
                this.getProducts();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/products/' + event.row.productId]);
        }
    }

    downloadCsv() {
        var csv = new Angular5Csv(_.map(this.products, g => { return { productId: g.productId, groupId: g.groupId, productName: g.productName, productFee: g.productFee, planName: g.planName }; }),
            'LA_Plan_csv_' + moment().format('YYYY-MM-DD'),
            {
                'showLabels': true, headers: ["Plan Id", "Sponsor Id", "Product Name", "Product Fee", "Plan Name"],
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/products/products.component.ts